import angular from 'angular'
import 'ui-select'
import dropdown from 'ui-bootstrap4/src/dropdown'
import { EditIcdCorporationComponent } from './edit-icd-corporation/edit-icd-corporation.component';
import { EditIcdOfficeComponent } from './edit-icd-office/edit-icd-office.component';
import { ListIcdCorporationsContainerComponent } from './list-icd-corporation/list-icd-corporations-container.component';
import { ListIcdOfficesContainerComponent } from './list-icd-office/list-icd-offices-container.component';
import { ListIcdOfficesComponent } from './list-icd-office/list-icd-offices.component';
import { IcdCorporationDashboardModule } from './dashboard/icd-corporation-dashboard.module'
import { IcdCorporationDashboardRoutingModule } from './dashboard/icd-corporation-dashboard-routing.module'
import { IcdCorporationRoutingModule } from './icd-corporation-routing.module';
import { MoveMeridianIdModule } from './move-meridian-id/move-meridian-id.module';

export const IcdCorporationModule = angular
    .module("apex.mainApp.icdCorporation", [
        'ui.select',
        dropdown,
        MoveMeridianIdModule,
        IcdCorporationDashboardRoutingModule,
        IcdCorporationRoutingModule,
        IcdCorporationDashboardModule
    ])
    .component("apexEditIcdCorporation", EditIcdCorporationComponent)
    .component("apexEditIcdOffice", EditIcdOfficeComponent)
    .component("apexListIcdCorporationContainer", ListIcdCorporationsContainerComponent)
    .component("apexListIcdOfficesContainer", ListIcdOfficesContainerComponent)
    .component("apexListIcdOffices", ListIcdOfficesComponent)
    .name
